// Source of truth for these strings:
// packages/cdk/cloudflare/bounded-build/src/types.ts. Keep them string-pinned;
// wire:1 remains additive and callers must tolerate unknown response strings.
export const NON_TERMINAL_STATES = [
    'queued',
    'admitted',
    'executing',
    'preview_ready',
    'parked',
    'resuming',
    'promoting',
    'quarantined',
];
export const TERMINAL_STATES = [
    'promoted',
    'failed',
    'canceled',
    'rejected',
    'expired',
    'rebase_required',
    'reported',
];
export const RUN_STATES = [
    ...NON_TERMINAL_STATES,
    ...TERMINAL_STATES,
];
export const PARK_REASONS = ['gate', 'funding'];
export const FAILURE_REASONS = [
    'admission_rejected',
    'dispatch_timeout',
    'auth_revoked',
    'owner_changed',
    'policy_changed',
    'quarantine_forced',
    'bind_failed',
    'internal_error',
];
export const BUILD_REVIEW_CAPABILITY_SCHEMA = 'bounded.build-review-capability.v1';
export const BUILD_REVIEW_CAPABILITY_REFRESH_SCHEMA = 'bounded.build-review-capability-refresh.v1';
export const BUILD_DELEGATED_REVIEW_CAPABILITY_SCHEMA = 'bounded.build-delegated-review-capability.v1';
